AoPS.Utils.initKeyChain(AoPS, "Contests", "Views");

AoPS.Contests.Views = (function (Views) {
	// What happens when you go to /blah/register
	Views.ContestRegister = AoPS.View.extend({
		template_id: "#contest-register-tpl",
		className: "contest-landing-main",
		initialize: function (options) {
			this.vars = {};
			this.searches = {};
			var searchStr = window.location.search;
			if (searchStr) {
				var searches = searchStr.substring(1).split("&");
				_.each(
					searches,
					_.bind(function (str) {
						var parts = str.split("=");
						this.searches[parts[0]] = parts[1];
					}, this)
				);
			}

			this.flavor_method_name = this.model.get("flavor")
				? this.model.get("flavor").get("flavor_method_name")
				: null;
			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceBeforeRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceBeforeRender"]();
			}

			this.render();

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceAfterRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceAfterRender"]();
			}

			this.listenTo(this.model, "fetch", _.bind(this.render, this));
		},
		render: function () {
			this.getTemplateVariables();
			if (!this.model.get("isProduction")) {
				console.log("Displays on Test Servers Only:", this.vars);
			}

			this.$el.html(
				this.model.getCmsTemplate("#register-layout-tpl", this.vars) ||
					this.getTemplate(this.template_id, this.vars)
			);

			this.$overview = this.$(".overview-inner");
			this.$individual = this.$(".individual-inner");
			this.$team = this.$(".team-inner");
			this.$footer = this.$(".footer-inner");

			this.renderOverview();

			if (AoPS.session.logged_in && this.vars.registration_can_view) {
				this.renderIndividual();

				if (this.vars.team) {
					this.renderTeam();
					//move team div inside contest-practice-registration-form if the options indicate to do so
					//done this way to make it the last element inside
					if ((this.model.attributes.data || {}).move_team_inner) {
						$(
							".individual-inner .contest-landing-main .contest-practice-registration-form"
						).append($(".team-inner"));
					}
				}
			}

			this.$footer
				.empty()
				.html(this.model.getCmsTemplate("#register-footer-tpl", this.vars));

			AoPS.Contests.Utils.scrollTo(true);

			// immediately pull up initialization modal if user isn't initialized
			if (AoPS.session.logged_in && !AoPS.session.initialized) {
				AoPS.Initialize.display({escapable: true});
			} else if (AoPS.isUserCoppaBlocked()) {
				AoPS.displayCoppaBlockedModal({escapable: true});
			}
		},
		renderOverview: function () {
			if (AoPS.session.logged_in) {
				if (
					this.flavor_method_name &&
					_.isFunction(
						this["process" + this.flavor_method_name + "BeforeRender"]
					)
				) {
					this["process" + this.flavor_method_name + "BeforeRender"]();
				}

				this.$overview
					.empty()
					.html(this.model.getCmsTemplate("#register-overview-tpl", this.vars));

				if (
					this.flavor_method_name &&
					_.isFunction(
						this["process" + this.flavor_method_name + "AfterRender"]
					)
				) {
					this["process" + this.flavor_method_name + "AfterRender"]();
				}
			} else {
				this.$overview
					.empty()
					.html(
						this.model.getCmsTemplate("#register-logged-out-tpl", this.vars)
					);

				if (this.$(".online-login-button").length) {
					this.$(".online-login-button").click(function () {
						AoPS.login.display();
					});
				}
			}
		},
		renderIndividual: function () {
			this.setIndividualVars();
			if (this.blockRegistration) {
				this.individualView = new Views.ContestRegistrationFull({
					model: this.model,
					contestView: this,
				});
			} else if (this.checkCoppa) {
				this.individualView = new Views.ContestRegisterCoppaCheck({
					model: this.model,
					contestView: this,
				});
			} else if (this.blockCoppa) {
				this.individualView = new Views.ContestRegisterCoppaBlock({
					model: this.model,
					contestView: this,
				});
			} else {
				this.individualView = new Views.ContestRegisterIndividual({
					model: this.model,
					contestView: this,
				});
			}
			this.individualView.$el.appendTo(this.$individual);
			if (
				!this.blockRegistration &&
				this.searches.invite &&
				!this.model.get("fetching_invite") &&
				!this.model.get("current_invite")
			) {
				this.model.getInvitationData(
					this.searches.invite,
					_.bind(function () {
						var invitation = this.model.get("current_invitation");
						if (invitation.type !== "participant") {
							var newPath =
								window.location.protocol +
								"//" +
								window.location.hostname +
								"/contests/" +
								this.model.get("contest_hash");
							if (invitation.type === "grader") {
								newPath += "/grader" + window.location.search;
							}
							window.location.href = newPath;
							return;
						}
						if (invitation.accepted) {
							if (!invitation.accepted_by_self) {
								AoPS.Contests.Utils.CreateModalAlert(
									"This invitation has already been accepted by a different user!  Click 'OK' to register as " +
										AoPS.session.username +
										" without an invitation, or log in as the correct user.",
									function () {
										// reload without invite
										window.location.href = window.location.pathname;
									},
									{
										closeX: false,
										force_response: true,
									}
								);
							}
						} else {
							var $confirmation = $("<div />").append(
								"<p>You are currently logged in as <b>" +
									(AoPS.session.username || AoPS.session.email) +
									'</b>.  Click "Continue" to link your registration to this user.</p><p>If you want to link your registration to a different user account, please log in with the correct account before continuing.</p>'
							);

							AoPS.Contests.Utils.CreateModalAlert(
								$confirmation,
								_.bind(function () {
									if (!this.checkCoppa) {
										// invite gets linked after
										// coppa check, so only do this if
										// we're already past coppa check or
										// contest doesn't have coppa at all

										if (invitation) {
											var data = {};
											data.invite_id = invitation.invite_id;
											Object.assign(data, invitation.data);
											if (this.vars.registration.contest_registration_id) {
												// make sure we don't overwrite anything
												// that already exists
												Object.assign(data, this.vars.registration);
												// include custom props
												Object.assign(data, this.vars.registration.data);
											}

											this.model.registerUser(
												data,
												_.bind(function () {
													AoPS.Contests.Utils.CreateModalAlert(
														"Your invitation has been successfully linked!"
													);
												})
											);
										}
									}
								}, this),
								{
									alert_button_ok: "Continue",
									closeX: false,
									force_response: true,
								}
							);
						}
					}, this)
				);
			}
		},
		renderTeam: function () {
			this.setIndividualVars();
			if (!this.checkCoppa && !this.blockCoppa) {
				this.teamView = new Views.ContestRegisterTeam({
					model: this.model,
					contestView: this,
				});
				this.teamView.$el.appendTo(this.$team);
			}
		},
		getTemplateVariables: function () {
			return _.extend(this.vars, this.model.export());
		},
		constructCrumbs: function () {
			return [
				{
					text:
						this.model.get("contest_crumb_name") ||
						this.model.get("contest_name"),
					url: "/contests/" + this.model.get("contest_hash"),
				},
				{text: "Register"},
			];
		},
		setIndividualVars: function () {
			var hasCoppa = this.model.get("flavor").get("has_coppa");
			var isRegistered = this.vars.registration.contest_registration_id > 0;
			var isMaxed = !this.vars.registration_cap.allow_new_registration;
			var allowInvites = this.vars.registration_cap.allow_accept_invite;
			var isCoppa = this.vars.registration.is_coppa;
			var coppaCleared = this.vars.registration.coppa_cleared;
			var window = this.model.computeWindow();

			this.blockRegistration =
				isMaxed && !isRegistered && (!allowInvites || !this.searches.invite);

			this.checkCoppa =
				window.get("official_registration_can_access") &&
				hasCoppa &&
				!isRegistered;
			this.blockCoppa =
				window.get("official_registration_can_access") &&
				hasCoppa &&
				isCoppa &&
				!coppaCleared;
		},
		processMathcountsWeekOnceAfterRender: function () {
			// Listeners are usually placed here.
		},
		processMathcountsWeekAfterRender: function () {
			// Add more functionality here after each time it rerenders
		},
		processF_maBeforeRender: function () {
			AoPS.Contests.Utils.initStaggerVars.call(this, "F_ma");
		},
		processF_maAfterRender: function () {
			AoPS.Contests.Utils.initStaggerVars.call(this, "F_ma");
		},
	});

	// The actual form where you register
	Views.ContestRegisterIndividual = AoPS.View.extend({
		template_id: "#contest-register-individual-tpl",
		className: "contest-landing-main",
		initialize: function (options) {
			this.contestView = options.contestView;
			this.isEditMode(!this.contestView.vars.registration.is_complete);

			this.flavor_method_name = this.model.get("flavor")
				? this.model.get("flavor").get("flavor_method_name")
				: null;
			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceBeforeRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceBeforeRender"]();
			}

			this.render();

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceAfterRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceAfterRender"]();
			}
		},
		isEditMode: function (val) {
			if (!_.isUndefined(val)) {
				this.is_edit_mode = val ? true : false;
			}

			if (!this.contestView.vars.registration.is_complete) {
				this.is_edit_mode = true;
			}

			return this.is_edit_mode ? true : false;
		},
		getIsOfficial: function () {
			if (this.vars.official_registration_can_access) {
				return parseInt(
					this.$("input[data-field='is_official']:checked").val() || 0
				)
					? 1
					: 0;
			} else {
				return 0;
			}
		},
		getIsPublic: function () {
			return parseInt(
				this.$("input[data-field='is_public']:checked").val() || 0
			)
				? 1
				: 0;
		},
		validateAndSubmitMathcountsWeek: function (success) {
			success = _.isFunction(success) ? success : function () {};

			if (
				this.vars.official_registration_can_access &&
				this.$("input[data-field='is_official']:checked").length < 1
			) {
				AoPS.Contests.Utils.CreateModalAlert(
					"Please indicate whether you would like to compete officially."
				);
				return;
			}

			if (this.$("input[data-field='is_public']:checked").length < 1) {
				AoPS.Contests.Utils.CreateModalAlert(
					"Please indicate whether you would like to appear on public contest leaderboards."
				);
				return;
			}

			var data = {
				is_official: this.getIsOfficial(),
				is_public: this.getIsPublic(),
			};
			var missing = [];
			var fields = this.model.fieldsForMathcountsWeekRegistration;

			if (data.is_official) {
				_.each(
					fields,
					_.bind(function (field) {
						var value =
							this.$("input[data-field='" + field.name + "']").val() || "";
						if (value.length) {
							data[field.name] = value;
						} else {
							missing.push(field);
						}
					}, this)
				);
			}

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter your ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitMathcounts: function (success) {
			success = _.isFunction(success) ? success : function () {};

			if (this.vars.unofficial_registration_has_started) {
				success();
				return;
			}

			var data = {
				is_official: 1,
				is_public: 0,
				is_complete: 1,
				student_first_name: this.$("input[name='student_first_name']").val(),
				student_last_name: this.$("input[name='student_last_name']").val(),
				student_email: this.$("input[name='student_email']").val(),
				school_name: this.$("input[name='school_name']").val(),
				school_city: this.$("input[name='school_city']").val(),
				school_state: this.$("input[name='school_state']").val(),
				school_zip: this.$("input[name='school_zip']").val(),
				grade: this.$("select[name='grade']").val(),
				guardian_first_name: this.$("input[name='guardian_first_name']").val(),
				guardian_last_name: this.$("input[name='guardian_last_name']").val(),
				guardian_email_address: this.$(
					"input[name='guardian_email_address']"
				).val(),
				home_address: this.$("input[name='home_address']").val(),
				home_city: this.$("input[name='home_city']").val(),
				home_state: this.$("input[name='home_state']").val(),
				home_zip: this.$("input[name='home_zip']").val(),
				school_registered: this.$("select[name='school_registered']").val(),
			};

			var blank_fields = [];
			for (var [field_key, field_value] of Object.entries(data)) {
				if (field_value === "" || field_value === null) {
					blank_fields.push(field_key.replaceAll("_", " "));
				}
			}
			if (blank_fields.length > 0) {
				var warning_text = "The following fields need to be filled in:\n";
				for (var field of blank_fields) {
					warning_text += "\n" + field;
				}
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.css("white-space", "pre")
						.text(warning_text)
				);
			} else if (
				!data.student_email.match(
					/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				)
			) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid student email address!")
				);
			} else if (
				!data.guardian_email_address.match(
					/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				)
			) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid parent/guardian email address!")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitAMC1012: function (success) {
			success = _.isFunction(success) ? success : function () {};

			if (this.vars.unofficial_registration_has_started) {
				success();
				return;
			}

			var data = {
				is_official: 1, // amc 10/12 does not have unofficial reg
				is_public: 0, // amc 10/12 does not have aops leaderboards (?)
				is_complete: 1,
				parent_proctor_email: this.$(
					"input[name='parent_proctor_email']"
				).val(),
				add_to_mailing_list: parseInt(
					this.$("input[name='add_to_mailing_list']:checked").val() || "0"
				),
			};

			if (
				!data.parent_proctor_email.match(
					/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				)
			) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid email address!")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitUsemo: function (success) {
			success = _.isFunction(success) ? success : function () {};

			var data = {
				is_official: 1, // usemo does not have unofficial reg
				is_public: 0, // usemo does not have aops leaderboards, ok to remove per evan chen
			};
			var missing = [];
			var fields = this.model.fieldsForUsemoRegistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on) {
						if (!data[field.depends_on]) {
							// the field this depends on is not completed
							return;
						}
						if (data[field.depends_on] !== field.dependency_value) {
							// this is not required, but put it in json to make
							// data consistent
							data[field.name] = "";
							return;
						}
					}
					var selector =
						field.type === "radio"
							? `input[name='${field.name}']:checked`
							: `input[data-field='${field.name}']`;
					var value = this.$(selector).val() || "";

					if (value.length) {
						data[field.name] = value;
					} else {
						missing.push(field);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter your ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		// Copy of validateAndSubmitAMC1012()
		validateAndSubmitAMC8: function (success) {
			success = _.isFunction(success) ? success : function () {};

			if (this.vars.unofficial_registration_has_started) {
				success();
				return;
			}

			var data = {
				is_official: 1, // amc 8 does not have unofficial reg
				is_public: 0, // amc 8 does not have aops leaderboards
				is_complete: 1,
				parent_proctor_email: this.$(
					"input[name='parent_proctor_email']"
				).val(),
				add_to_mailing_list: parseInt(
					this.$("input[name='add_to_mailing_list']:checked").val() || "0"
				),
			};

			if (
				!data.parent_proctor_email.match(
					/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				)
			) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid email address!")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitAime: function (success) {
			success = _.isFunction(success) ? success : function () {};

			if (this.vars.unofficial_registration_has_started) {
				success();
				return;
			}

			var data = {
				is_official: 1, // aoime does not have unofficial reg
				is_public: 0, // aoime does not have aops leaderboards (?)
				is_complete: this.vars.registration.data.is_preregistered ? 1 : 0,
			};
			var missing = [];
			var invalid = [];
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForAoimeRegistration
				: this.model.fieldsForAoimePreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on) {
						if (data[field.depends_on] !== field.dependency_value) {
							// this is not required, but put it in json to make
							// data consistent
							data[field.name] = "";
							return;
						}
					}

					if (field.type === "radio") {
						data[field.name] =
							this.$("input[name='" + field.name + "']:checked").val() || "";
					} else if (field.type === "select") {
						data[field.name] = this.$(
							"select[name='" + field.name + "']"
						).val();
					} else if (field.type === "check") {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).prop("checked")
							? field.value_checked
							: field.value_default;
					} else {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).val();
					}

					data[field.name] = data[field.name] || "";

					if (!data[field.name].length && !field.is_optional) {
						missing.push(field);
					}

					if (
						field.name.match(/email$/) &&
						data[field.name] &&
						!data[field.name].match(
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					) {
						invalid.push(field);
					}

					if (field.is_integer) {
						data[field.name] = parseInt(data[field.name]);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else if (invalid.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid ")
						.append(this.createFieldNameList(invalid))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitMaaOlympiad: function (success) {
			success = _.isFunction(success) ? success : function () {};

			if (this.vars.unofficial_registration_has_started) {
				success();
				return;
			}

			var data = {
				is_official: 1, // uso(j)mo does not have unofficial reg
				is_public: 0, // uso(j)mo does not have aops leaderboards
				is_complete: this.vars.registration.data.is_preregistered ? 1 : 0,
			};
			var missing = [];
			var invalid = [];
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForMaaOlympiadRegistration
				: this.model.fieldsForMaaOlympiadPreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on) {
						if (data[field.depends_on] !== field.dependency_value) {
							// this is not required, but put it in json to make
							// data consistent
							data[field.name] = "";
							return;
						}
					}

					if (field.type === "radio") {
						data[field.name] =
							this.$("input[name='" + field.name + "']:checked").val() || "";
					} else if (field.type === "select") {
						data[field.name] = this.$(
							"select[name='" + field.name + "']"
						).val();
					} else if (field.type === "check") {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).prop("checked")
							? field.value_checked
							: field.value_default;
					} else {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).val();
					}

					data[field.name] = data[field.name] || "";

					if (!data[field.name].length && !field.is_optional) {
						missing.push(field);
					}

					if (
						field.name.match(/email$/) &&
						data[field.name] &&
						!data[field.name].match(
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					) {
						invalid.push(field);
					}

					if (field.is_integer) {
						data[field.name] = parseInt(data[field.name]);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else if (invalid.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid ")
						.append(this.createFieldNameList(invalid))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitCmcOlympiad: function (success) {
			success = _.isFunction(success) ? success : function () {};

			if (this.vars.unofficial_registration_has_started) {
				success();
				return;
			}

			var data = {
				is_official: 1,
				is_public: 0, // All CMC results appear on leaderboards, but without username/name
				is_complete: this.vars.registration.data.is_preregistered ? 1 : 0,
			};
			var missing = [];
			var invalid = [];
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForCmcOlympiadRegistration
				: this.model.fieldsForCmcOlympiadPreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on) {
						if (data[field.depends_on] !== field.dependency_value) {
							// this is not required, but put it in json to make
							// data consistent
							data[field.name] = "";
							return;
						}
					}

					if (field.type === "radio") {
						data[field.name] =
							this.$("input[name='" + field.name + "']:checked").val() || "";
					} else if (field.type === "select") {
						data[field.name] = this.$(
							"select[name='" + field.name + "']"
						).val();
					} else if (field.type === "check") {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).prop("checked")
							? field.value_checked
							: field.value_default;
					} else {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).val();
					}

					data[field.name] = data[field.name] || "";

					if (!data[field.name].length && !field.is_optional) {
						missing.push(field);
					}

					if (
						field.name.match(/email$/) &&
						data[field.name] &&
						!data[field.name].match(
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					) {
						invalid.push(field);
					}

					if (field.is_integer) {
						data[field.name] = parseInt(data[field.name]);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else if (invalid.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid ")
						.append(this.createFieldNameList(invalid))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitUSABO: function (success = () => {}) {
			if (!this.vars.official_registration_has_started) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the USABO has not begun. Please check back later."
						)
				);
				return;
			}
			if (this.vars.official_registration_has_ended) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Registration for the USABO has ended.")
				);
				return;
			}

			var data = {
				is_official: 1, // no unofficial registrations
				is_public: 0, // no leaderboards
				is_complete: 0,
			};
			var missing = [];
			var fields = this.model.fieldsForUSABORegistration;

			_.each(
				fields,
				_.bind(function (field) {
					data[field.name] = this.$(
						"input[data-field='" + field.name + "']"
					).val();

					data[field.name] = data[field.name] || "";

					if (!data[field.name].length && !field.is_optional) {
						missing.push(field);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitMuAlphaTheta: function (success = () => {}) {
			if (!this.vars.official_registration_has_started) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the Mu Alpha Theta Online Ciphering Contest has not begun. Please check back later."
						)
				);
				return;
			}
			if (this.vars.official_registration_has_ended) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the Mu Alpha Theta Online Ciphering Contest has ended."
						)
				);
				return;
			}

			var data = {
				is_official: 1, // no unofficial registrations
				is_public: 0, // no leaderboards
				is_complete: this.vars.registration.data.is_preregistered ? 1 : 0,
			};
			var missing = [];
			var invalid = [];
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForMuAlphaThetaRegistration
				: this.model.fieldsForMuAlphaThetaPreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.type === "radio") {
						data[field.name] =
							this.$("input[name='" + field.name + "']:checked").val() || "";
					} else {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).val();
					}
					data[field.name] = data[field.name] || "";

					if (!data[field.name].length && !field.is_optional) {
						missing.push(field);
					}

					if (
						field.name.match(/email$/) &&
						data[field.name] &&
						!data[field.name].match(
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					) {
						invalid.push(field);
					}

					if (field.is_integer) {
						data[field.name] = parseInt(data[field.name]);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else if (invalid.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid ")
						.append(this.createFieldNameList(invalid))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitGaimElementary: function (success = () => {}) {
			if (!this.vars.official_registration_has_started) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the Mu Alpha Theta Online Ciphering Contest has not begun. Please check back later."
						)
				);
				return;
			}
			if (this.vars.official_registration_has_ended) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the Mu Alpha Theta Online Ciphering Contest has ended."
						)
				);
				return;
			}

			var data = {
				is_official: 1, // no unofficial registrations
				is_public: 0, // no leaderboards
				is_complete: this.vars.registration.data.is_preregistered ? 1 : 0,
			};
			var missing = [];
			var invalid = [];
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForGaimElementaryRegistration
				: this.model.fieldsForGaimElementaryPreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.type === "radio") {
						data[field.name] =
							this.$("input[name='" + field.name + "']:checked").val() || "";
					} else if (field.type === "select") {
						data[field.name] = this.$(
							"select[name='" + field.name + "']"
						).val();
					} else {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).val();
					}
					data[field.name] = data[field.name] || "";

					if (!data[field.name].length && !field.is_optional) {
						missing.push(field);
					}

					if (
						field.name.match(/email$/) &&
						data[field.name] &&
						!data[field.name].match(
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					) {
						invalid.push(field);
					}

					if (field.is_integer) {
						data[field.name] = parseInt(data[field.name]);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else if (invalid.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid ")
						.append(this.createFieldNameList(invalid))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitGaimMiddle: function (success = () => {}) {
			if (!this.vars.official_registration_has_started) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the Mu Alpha Theta Online Ciphering Contest has not begun. Please check back later."
						)
				);
				return;
			}
			if (this.vars.official_registration_has_ended) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the Mu Alpha Theta Online Ciphering Contest has ended."
						)
				);
				return;
			}

			var data = {
				is_official: 1, // no unofficial registrations
				is_public: 0, // no leaderboards
				is_complete: this.vars.registration.data.is_preregistered ? 1 : 0,
			};
			var missing = [];
			var invalid = [];
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForGaimMiddleRegistration
				: this.model.fieldsForGaimMiddlePreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.type === "radio") {
						data[field.name] =
							this.$("input[name='" + field.name + "']:checked").val() || "";
					} else if (field.type === "select") {
						data[field.name] = this.$(
							"select[name='" + field.name + "']"
						).val();
					} else {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).val();
					}
					data[field.name] = data[field.name] || "";

					if (!data[field.name].length && !field.is_optional) {
						missing.push(field);
					}

					if (
						field.name.match(/email$/) &&
						data[field.name] &&
						!data[field.name].match(
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					) {
						invalid.push(field);
					}

					if (field.is_integer) {
						data[field.name] = parseInt(data[field.name]);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else if (invalid.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid ")
						.append(this.createFieldNameList(invalid))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		validateAndSubmitF_ma: function (success = () => {}) {
			if (!this.vars.official_registration_has_started) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text(
							"Registration for the F=ma has not begun. Please check back later."
						)
				);
				return;
			}
			if (this.vars.official_registration_has_ended) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Registration for the F=ma has ended.")
				);
				return;
			}

			var data = {
				is_official: 1, // no unofficial registrations
				is_public: 0, // no leaderboards
				is_complete: this.vars.registration.data.is_preregistered ? 1 : 0,
			};
			var missing = [];
			var invalid = [];
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForF_maRegistration
				: this.model.fieldsForF_maPreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.type === "radio") {
						data[field.name] =
							this.$("input[name='" + field.name + "']:checked").val() || "";
					} else if (field.type === "select") {
						data[field.name] = this.$(
							"select[name='" + field.name + "']"
						).val();
					} else {
						data[field.name] = this.$(
							"input[data-field='" + field.name + "']"
						).val();
					}

					data[field.name] = data[field.name] || "";
					if (
						!data[field.name].length &&
						!field.is_optional &&
						(!field.depends_on ||
							field.dependency_value === data[field.depends_on]) // check if dependency value is triggered
					) {
						missing.push(field);
					}

					if (
						field.name.match(/email$/) &&
						data[field.name] &&
						!data[field.name].match(
							/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
					) {
						invalid.push(field);
					}

					if (field.is_integer) {
						data[field.name] = parseInt(data[field.name]);
					}
				}, this)
			);

			if (missing.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a value for ")
						.append(this.createFieldNameList(missing))
						.append(".")
				);
			} else if (invalid.length) {
				AoPS.Contests.Utils.CreateModalAlert(
					$("<div />")
						.css("max-width", "480px")
						.text("Please enter a valid ")
						.append(this.createFieldNameList(invalid))
						.append(".")
				);
			} else {
				success(data);
			}
		},
		createFieldNameList: function (fields) {
			var $concat_fields = $("<span />");
			for (var i = 0; i < fields.length; i++) {
				$concat_fields.append(
					$("<strong />").text(fields[i].caption_short || fields[i].caption)
				);
				if (i < fields.length - 2) {
					$concat_fields.append(", ");
				} else if (i < fields.length - 1) {
					$concat_fields.append((i > 0 ? "," : "") + " and ");
				}
			}

			return $concat_fields;
		},
		makeMathcountsWeekConfirmationList: function (data) {
			var $ul = $("<ul />");

			data = _.extend(
				_.reduce(
					this.model.fieldsForMathcountsWeekRegistration,
					_.bind(function (carry, field) {
						carry[field.name] = this.vars.registration.data[field.name];
						return carry;
					}, this),
					_.reduce(
						["is_official"],
						_.bind(function (carry, field_name) {
							carry[field_name] = this.vars.registration[field_name];
							return carry;
						}, this),
						{}
					)
				),
				data
			);

			$ul.append(
				$("<li />").text(
					data.is_official
						? "You are competing officially as a MATHCOUNTS Mathlete."
						: "You are competing as a MATHCOUNTS Friend."
				)
			);

			if (data.is_official) {
				_.each(
					this.model.fieldsForMathcountsWeekRegistration,
					_.bind(function (field) {
						$ul.append(
							$("<li />")
								.text("Your " + field.caption + ": ")
								.append($("<b />").text(data[field.name]))
						);
					}, this)
				);
			}

			if (!_.isUndefined(data.is_public)) {
				$ul.append(
					$("<li />").text(
						data.is_public
							? "Your username will appear on public contest leaderboards."
							: "Your username will not appear on public contest leaderboards."
					)
				);
			}

			return $ul;
		},
		makeMathcountsConfirmationList: function (data) {
			if (data.hasOwnProperty("parent_proctor_email")) {
				//imitate AMC1012
				//change this if AMC 1012 changes
				this.makeAMC1012ConfirmationList(data);
			} else {
				//imitate Mathcounts Week
				//change this if that one changes
				this.makeMathcountsWeekConfirmationList(data);
			}
		},
		makeAMC1012ConfirmationList: function (data) {
			var $ul = $("<ul />").append(
				$("<li />")
					.text("Parent Proctor Email: ")
					.append($("<b />").text(data.parent_proctor_email))
			);

			if (data.add_to_mailing_list) {
				$ul.append(
					$("<li />").text(
						"Add parent proctor email to the AoPS Online mailing list."
					)
				);
			}

			return $ul;
		},
		makeUsemoConfirmationList: function (data) {
			var $ul = $("<ul />");
			var fields = this.model.fieldsForUsemoRegistration;
			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on) {
						// dependents are not listed separately
						return;
					}
					var displayData = data[field.name];
					if (field.type === "radio") {
						var haystack = this.vars[field.name + "s"];
						var option = _.findWhere(haystack, {value: data[field.name]});
						if (option) {
							displayData = option.label;
						}
					}

					if (field.dependent) {
						var dependent = _.findWhere(fields, {name: field.dependent});
						if (dependent && data[field.name] === dependent.dependency_value) {
							displayData += " " + data[dependent.name];
						}
					}
					$ul.append(
						$("<li />")
							.text("Your " + field.caption + ": ")
							.append($("<b />").text(displayData))
					);
				}, this)
			);

			return $ul;
		},
		makeAMC8ConfirmationList: function (data) {
			return $("");
		},
		makeAimeConfirmationList: function (data) {
			if (this.vars.unofficial_registration_has_started) {
				return $("");
			}

			var $ul = $("<ul />");
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForAoimeRegistration
				: this.model.fieldsForAoimePreregistration;
			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on) {
						// dependents are not listed separately
						return;
					}
					var displayData = data[field.name];

					if (["radio", "select"].indexOf(field.type) >= 0) {
						var haystack = this.vars[field.name + "s"];
						var option = _.findWhere(haystack, {value: data[field.name]});
						if (option) {
							displayData = option.label;
						}
					}

					if (field.dependent) {
						var dependent = _.findWhere(fields, {name: field.dependent});
						if (dependent && data[field.name] === dependent.dependency_value) {
							displayData =
								(field.dependency_label || displayData) +
								" – " +
								data[dependent.name];
						}
					}

					if (!field.is_optional || data[field.name]) {
						if (field.type === "check") {
							$ul.append(
								$("<li />")
									.text(field.caption + ": ")
									.append(
										$("<b />").text(
											data[field.name] === field.value_checked
												? field.label_checked
												: field.label_default
										)
									)
							);
						} else {
							$ul.append(
								$("<li />")
									.text(field.caption + ": ")
									.append($("<b />").text(displayData))
							);
						}
					}
				}, this)
			);

			return $ul;
		},
		makeMaaOlympiadConfirmationList: function (data) {
			if (this.vars.unofficial_registration_has_started) {
				return $("");
			}

			var $ul = $("<ul />");
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForMaaOlympiadRegistration
				: this.model.fieldsForMaaOlympiadPreregistration;
			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on || field.concats_to) {
						// dependents are not listed separately
						return;
					}

					var displayData = data[field.name];

					if (["radio", "select"].indexOf(field.type) >= 0) {
						var haystack = this.vars[field.name + "s"];
						var option = _.findWhere(haystack, {value: data[field.name]});
						if (option) {
							displayData = option.label;
						}
					}

					if (field.dependent) {
						var dependent = _.findWhere(fields, {name: field.dependent});
						if (dependent && data[field.name] === dependent.dependency_value) {
							displayData =
								(field.dependency_label || displayData) +
								" – " +
								data[dependent.name];
						}
					}

					// Format address
					if (field.name === "home_address") {
						displayData = _.reduce(
							field.concat_list,
							function (memo, to_concat_name) {
								var glue = to_concat_name === "home_zip" ? " " : ", ";
								var val = data[to_concat_name] ? data[to_concat_name] : "";
								return memo + glue + val;
							},
							displayData
						);
					}

					if (!field.is_optional || data[field.name]) {
						if (field.type === "check") {
							$ul.append(
								$("<li />")
									.text(field.caption + ": ")
									.append(
										$("<b />").text(
											data[field.name] === field.value_checked
												? field.label_checked
												: field.label_default
										)
									)
							);
						} else {
							$ul.append(
								$("<li />")
									.text(field.caption + ": ")
									.append($("<b />").text(displayData))
							);
						}
					}
				}, this)
			);

			return $ul;
		},
		makeCmcOlympiadConfirmationList: function (data) {
			if (this.vars.unofficial_registration_has_started) {
				return $("");
			}

			var $ul = $("<ul />");
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForCmcOlympiadRegistration
				: this.model.fieldsForCmcOlympiadPreregistration;
			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on || field.concats_to) {
						// dependents are not listed separately
						return;
					}

					var displayData = data[field.name];

					if (["radio", "select"].indexOf(field.type) >= 0) {
						var haystack = this.vars[field.name + "s"];
						var option = _.findWhere(haystack, {value: data[field.name]});
						if (option) {
							displayData = option.label;
						}
					}

					if (field.dependent) {
						var dependent = _.findWhere(fields, {name: field.dependent});
						if (dependent && data[field.name] === dependent.dependency_value) {
							displayData =
								(field.dependency_label || displayData) +
								" " +
								data[dependent.name];
						}
					}

					// Format address
					if (field.name === "home_address") {
						displayData = _.reduce(
							field.concat_list,
							function (memo, to_concat_name) {
								var glue = to_concat_name === "home_zip" ? " " : ", ";
								var val = data[to_concat_name] ? data[to_concat_name] : "";
								return memo + glue + val;
							},
							displayData
						);
					}

					if (!field.is_optional || data[field.name]) {
						if (field.type === "check") {
							$ul.append(
								$("<li />")
									.text(field.caption + ": ")
									.append(
										$("<b />").text(
											data[field.name] === field.value_checked
												? field.label_checked
												: field.label_default
										)
									)
							);
						} else {
							$ul.append(
								$("<li />")
									.text(field.caption + ": ")
									.append($("<b />").text(displayData))
							);
						}
					}
				}, this)
			);

			return $ul;
		},
		makeUSABOConfirmationList: function (data) {
			var $ul = $("<ul />");
			var fields = this.model.fieldsForUSABORegistration;
			_.each(
				fields,
				_.bind(function (field) {
					var displayData = data[field.name];
					if (!field.is_optional || data[field.name]) {
						$ul.append(
							$("<li />")
								.text(field.caption + ": ")
								.append($("<b />").text(displayData))
						);
					}
				}, this)
			);

			return $ul;
		},
		makeMuAlphaThetaConfirmationList: function (data) {
			var $ul = $("<ul />");
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForMuAlphaThetaRegistration
				: this.model.fieldsForMuAlphaThetaPreregistration;
			_.each(
				fields,
				_.bind(function (field) {
					var displayData = data[field.name];

					var option;
					if (field.type === "radio") {
						option = this.$el.find("input[name='" + field.name + "']:checked");
						if (option) {
							displayData = option.parent().text().trim();
						}
					} else if (field.type === "select") {
						option = this.$el.find(
							"select[name='" + field.name + "'] > option:checked"
						);
						if (option) {
							displayData = option.text().trim();
						}
					}

					if (!field.is_optional || data[field.name]) {
						$ul.append(
							$("<li />")
								.text(field.caption + ": ")
								.append($("<b />").text(displayData))
						);
					}
				}, this)
			);

			return $ul;
		},
		makeGaimElementaryConfirmationList: function (data) {
			var $ul = $("<ul />");
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForGaimElementaryRegistration
				: this.model.fieldsForGaimElementaryPreregistration;
			_.each(
				fields,
				_.bind(function (field) {
					var displayData = data[field.name];

					var option;
					if (field.type === "radio") {
						option = this.$el.find("input[name='" + field.name + "']:checked");
						if (option) {
							displayData = option.parent().text().trim();
						}
					} else if (field.type === "select") {
						option = this.$el.find(
							"select[name='" + field.name + "'] > option:checked"
						);
						if (option) {
							displayData = option.text().trim();
						}
					}

					if (!field.is_optional || data[field.name]) {
						$ul.append(
							$("<li />")
								.text(field.caption + ": ")
								.append($("<b />").text(displayData))
						);
					}
				}, this)
			);

			return $ul;
		},
		makeGaimMiddleConfirmationList: function (data) {
			var $ul = $("<ul />");
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForGaimMiddleRegistration
				: this.model.fieldsForGaimMiddlePreregistration;
			_.each(
				fields,
				_.bind(function (field) {
					var displayData = data[field.name];

					var option;
					if (field.type === "radio") {
						option = this.$el.find("input[name='" + field.name + "']:checked");
						if (option) {
							displayData = option.parent().text().trim();
						}
					} else if (field.type === "select") {
						option = this.$el.find(
							"select[name='" + field.name + "'] > option:checked"
						);
						if (option) {
							displayData = option.text().trim();
						}
					}

					if (!field.is_optional || data[field.name]) {
						$ul.append(
							$("<li />")
								.text(field.caption + ": ")
								.append($("<b />").text(displayData))
						);
					}
				}, this)
			);

			return $ul;
		},
		makeF_maConfirmationList: function (data) {
			if (this.vars.unofficial_registration_has_started) {
				return $("");
			}

			var $ul = $("<ul />");
			var fields = this.vars.registration.data.is_preregistered
				? this.model.fieldsForF_maRegistration
				: this.model.fieldsForF_maPreregistration;

			_.each(
				fields,
				_.bind(function (field) {
					if (field.depends_on) {
						// dependents are not listed separately
						return;
					}

					var display_data = data[field.name];

					var option;
					if (field.type === "radio") {
						option = this.$el.find("input[name='" + field.name + "']:checked");
						if (option) {
							display_data = option.parent().text().trim();
						}
					} else if (field.type === "select") {
						option = this.$el.find(
							"select[name='" + field.name + "'] > option:checked"
						);
						if (option) {
							display_data = option.text().trim();
						}
					}

					if (field.dependent) {
						var dependent = _.findWhere(fields, {name: field.dependent});
						if (dependent && data[field.name] === dependent.dependency_value) {
							display_data =
								dependent.dependency_value.charAt(0).toUpperCase() +
								dependent.dependency_value.slice(1) +
								" – " +
								data[dependent.name];
						}
					}

					if (!field.is_optional || data[field.name]) {
						$ul.append(
							$("<li />")
								.text(field.caption + ": ")
								.append($("<b />").text(display_data))
						);
					}
				}, this)
			);

			return $ul;
		},

		confirmSubmission: function (data) {
			var $confirm = $("<div />")
				.css("max-width", "480px")
				.text(
					"Are you sure that you want to " +
						(this.vars.registration.contest_registration_id
							? "save your registration"
							: "submit your registration") +
						" for the " +
						this.vars.contest_name +
						"?"
				)
				.append(
					this["make" + this.flavor_method_name + "ConfirmationList"](data)
				);

			AoPS.Contests.Utils.CreateModalConfirm(
				$confirm,
				_.bind(function () {
					this.saveSubmission(data);
				}, this),
				null,
				{
					confirm_button_ok: this.vars.registration.contest_registration_id
						? "SAVE"
						: "REGISTER",
					confirm_button_cancel: "CANCEL",
				}
			);
		},
		saveSubmission: function (data) {
			this.isEditMode(false);
			this.model.registerUser(data);
		},
		cancelSubmission: function () {
			this.isEditMode(false);
			this.render();
		},
		renderCms: function () {
			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "BeforeRender"])
			) {
				this["process" + this.flavor_method_name + "BeforeRender"]();
			}

			this.$el.html(
				this.model.getCmsTemplate("#register-individual-tpl", this.vars)
			);

			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "AfterRender"])
			) {
				this["process" + this.flavor_method_name + "AfterRender"]();
			}
		},
		render: function () {
			this.vars = _.extend(
				{is_edit_mode: this.isEditMode()},
				this.model.export()
			);

			this.renderCms();

			if (this.isEditMode()) {
				var updateOfficial = _.bind(function () {
					var is_official = this.getIsOfficial();
					_.each(
						this.$(".contest-register-block"),
						_.bind(function (block) {
							var $block = $(block);
							if ($block.hasClass("show-always")) {
								$block.show();
							} else if (is_official && $block.hasClass("show-when-official")) {
								$block.show();
							} else if (
								!is_official &&
								$block.hasClass("show-when-not-official")
							) {
								$block.show();
							} else {
								$block.slideUp("fast");
							}
						}, this)
					);
				}, this);
				this.$("input[name='is_official']").click(updateOfficial);
				updateOfficial();

				this.$("button.register").click(
					_.bind(function (e) {
						e.preventDefault();

						// users need to have an Online account before registering
						if (!AoPS.session.initialized) {
							AoPS.Initialize.display({escapable: true});
							return;
						} else if (AoPS.isUserCoppaBlocked()) {
							AoPS.displayCoppaBlockedModal({escapable: true});
							return;
						}

						if (
							_.isFunction(this["validateAndSubmit" + this.flavor_method_name])
						) {
							this["validateAndSubmit" + this.flavor_method_name](
								_.bind(this.confirmSubmission, this)
							);
						} else {
							AoPS.Contests.Utils.CreateModalAlert(
								"Error: Missing Method " +
									"validateAndSubmit" +
									this.flavor_method_name
							);
						}
					}, this)
				);

				this.$("button.cancel").click(_.bind(this.cancelSubmission, this));
			} else {
				this.$("button.edit").click(
					_.bind(function () {
						this.isEditMode(true);
						this.render();
					}, this)
				);
			}
		},
		processUsemoBeforeRender: function () {
			this.vars.grades = [
				{
					label: "8th grade or below",
					value: "8",
					checked: false,
					is_other: false,
				},
				{
					label: "Freshman (9th)",
					value: "9",
					checked: false,
					is_other: false,
				},
				{
					label: "Sophomore (10th)",
					value: "10",
					checked: false,
					is_other: false,
				},
				{
					label: "Junior (11th)",
					value: "11",
					checked: false,
					is_other: false,
				},
				{
					label: "Senior (12th)",
					value: "12",
					checked: false,
					is_other: false,
				},
				{
					label: "Other:",
					value: "o",
					checked: false,
					is_other: true,
				},
			];
			if (this.vars.registration.data.grade) {
				var checkedGrade = _.findWhere(this.vars.grades, {
					value: this.vars.registration.data.grade,
				});
				if (checkedGrade) {
					checkedGrade.checked = true;
					this.vars.registration.data.grade_label = checkedGrade.label;
					if (checkedGrade.value === "o") {
						this.vars.registration.data.grade_label +=
							" " + this.vars.registration.data.grade_other;
					}
				}
			}

			this.vars.genders = [
				{
					label: "Female",
					value: "f",
					checked: false,
					is_other: false,
				},
				{
					label: "Male",
					value: "m",
					checked: false,
					is_other: false,
				},
				{
					label: "Non-binary",
					value: "x",
					checked: false,
					is_other: false,
				},
				{
					label: "Prefer Not To Say",
					value: "na",
					checked: false,
					is_other: false,
				},
				{
					label: "Other:",
					value: "o",
					checked: false,
					is_other: true,
				},
			];
			if (this.vars.registration.data.gender) {
				var checkedGender = _.findWhere(this.vars.genders, {
					value: this.vars.registration.data.gender,
				});
				if (checkedGender) {
					checkedGender.checked = true;
					this.vars.registration.data.gender_label = checkedGender.label;
					if (checkedGender.value === "o") {
						this.vars.registration.data.gender_label +=
							" " + this.vars.registration.data.gender_other;
					}
				}
			}
		},
		processAimeBeforeRender: function () {
			this.vars.ages = _.map(_.range(10, 20), function (value) {
				var label = value + "";
				if (value === 10) {
					label += " or below";
				} else if (value === 19) {
					label += " or above";
				}

				return {
					label: label,
					value: value,
					checked: false,
					is_other: false,
				};
			});
			if (this.vars.registration.data.age) {
				var checkedAge = _.findWhere(this.vars.ages, {
					value: this.vars.registration.data.age,
				});
				if (checkedAge) {
					checkedAge.checked = true;
					this.vars.registration.data.age_label = checkedAge.label;
				}
			}

			this.vars.grades = _.map(_.range(4, 14), function (value) {
				var label = value + "th grade";
				if (9 <= value && value <= 12) {
					label +=
						" (" +
						["Freshman", "Sophomore", "Junior", "Senior"][value - 9] +
						")";
				} else if (value === 4) {
					label += " or below";
				} else if (value === 13) {
					label += " or above";
				}

				return {
					label: label,
					value: value,
					checked: false,
					is_other: false,
				};
			});
			if (this.vars.registration.data.grade) {
				var checkedGrade = _.findWhere(this.vars.grades, {
					value: this.vars.registration.data.grade,
				});
				if (checkedGrade) {
					checkedGrade.checked = true;
					this.vars.registration.data.grade_label = checkedGrade.label;
				}
			}

			this.vars.genders = _.map(
				[
					{
						label: "Female",
						value: "F",
					},
					{
						label: "Male",
						value: "M",
					},
					{
						label: "Prefer not to specify",
						value: "U",
					},
					{
						label: "Prefer not to share",
						value: "P",
					},
					{
						label: "I am typing my gender in this blank:",
						value: "O",
						is_other: true,
					},
				],
				function (label) {
					return _.extend(
						{
							checked: false,
							is_other: false,
						},
						label
					);
				}
			);

			if (this.vars.registration.data.gender) {
				var checkedGender = _.findWhere(this.vars.genders, {
					value: this.vars.registration.data.gender,
				});
				if (checkedGender) {
					checkedGender.checked = true;
					this.vars.registration.data.gender_label = checkedGender.label;
					if (checkedGender.is_other) {
						this.vars.registration.data.gender_label =
							"Other – " + this.vars.registration.data.gender_other;
					}
				}
			}

			this.vars.will_usomos = [
				{
					label: "Yes",
					value: 1,
					checked: this.vars.registration.data.will_usomo === 1,
				},
				{
					label: "No",
					value: 0,
					checked: this.vars.registration.data.will_usomo === 0,
				},
			];

			if ([0, 1].indexOf(this.vars.registration.data.will_usomo) >= 0) {
				this.vars.registration.data.will_usomo_label =
					this.vars.registration.data.will_usomo === 1 ? "Yes" : "No";
			}
		},
		processMaaOlympiadBeforeRender: function () {
			this.vars.ages = _.map(_.range(10, 20), function (value) {
				var label = value + "";
				if (value === 10) {
					label += " or below";
				} else if (value === 19) {
					label += " or above";
				}

				return {
					label: label,
					value: value,
					checked: false,
					is_other: false,
				};
			});
			if (this.vars.registration.data.age) {
				var checkedAge = _.findWhere(this.vars.ages, {
					value: this.vars.registration.data.age,
				});
				if (checkedAge) {
					checkedAge.checked = true;
					this.vars.registration.data.age_label = checkedAge.label;
				}
			}

			this.vars.grades = _.map(_.range(4, 14), function (value) {
				var label = value + "th grade";
				if (9 <= value && value <= 12) {
					label +=
						" (" +
						["Freshman", "Sophomore", "Junior", "Senior"][value - 9] +
						")";
				} else if (value === 4) {
					label += " or below";
				} else if (value === 13) {
					label += " or above";
				}

				return {
					label: label,
					value: value,
					checked: false,
					is_other: false,
				};
			});
			if (this.vars.registration.data.grade) {
				var checkedGrade = _.findWhere(this.vars.grades, {
					value: this.vars.registration.data.grade,
				});
				if (checkedGrade) {
					checkedGrade.checked = true;
					this.vars.registration.data.grade_label = checkedGrade.label;
				}
			}

			this.vars.genders = _.map(
				[
					{
						label: "Female",
						value: "F",
					},
					{
						label: "Male",
						value: "M",
					},
					{
						label: "Prefer not to specify",
						value: "U",
					},
					{
						label: "Prefer not to share",
						value: "P",
					},
					{
						label: "I am typing my gender in this blank:",
						value: "O",
						is_other: true,
					},
				],
				function (label) {
					return _.extend(
						{
							checked: false,
							is_other: false,
						},
						label
					);
				}
			);

			if (this.vars.registration.data.gender) {
				var checkedGender = _.findWhere(this.vars.genders, {
					value: this.vars.registration.data.gender,
				});
				if (checkedGender) {
					checkedGender.checked = true;
					this.vars.registration.data.gender_label = checkedGender.label;
					if (checkedGender.is_other) {
						this.vars.registration.data.gender_label =
							"Other – " + this.vars.registration.data.gender_other;
					}
				}
			}

			this.vars.is_us_citizens = [
				{
					label: "Yes",
					value: 1,
					checked: this.vars.registration.data.is_us_citizen === 1,
				},
				{
					label: "No",
					value: 0,
					checked: this.vars.registration.data.is_us_citizen === 0,
				},
			];

			if ([0, 1].indexOf(this.vars.registration.data.is_us_citizen) >= 0) {
				this.vars.registration.data.is_us_citizen_label =
					this.vars.registration.data.is_us_citizen === 1 ? "Yes" : "No";
			}

			this.vars.will_mops = [
				{
					label: "Yes",
					value: 1,
					checked: this.vars.registration.data.will_mop === 1,
				},
				{
					label: "No",
					value: 0,
					checked: this.vars.registration.data.will_mop === 0,
				},
			];

			if ([0, 1].indexOf(this.vars.registration.data.will_mop) >= 0) {
				this.vars.registration.data.will_mop_label =
					this.vars.registration.data.will_mop === 1 ? "Yes" : "No";
			}
		},
		processCmcOlympiadBeforeRender: function () {
			this.vars.ages = _.map(_.range(10, 21), function (value) {
				var label = value + "";
				if (value === 10) {
					label += " or below";
				} else if (value === 20) {
					label += " or above";
				}

				return {
					label: label,
					value: value,
					checked: false,
					is_other: false,
				};
			});

			if (this.vars.registration.data.age) {
				var checkedAge = _.findWhere(this.vars.ages, {
					value: this.vars.registration.data.age,
				});
				if (checkedAge) {
					checkedAge.checked = true;
					this.vars.registration.data.age_label = checkedAge.label;
				}
			}

			this.vars.genders = _.map(
				[
					{
						label: "Female",
						value: "F",
					},
					{
						label: "Male",
						value: "M",
					},
					{
						label: "Prefer not to specify",
						value: "U",
					},
					{
						label: "Prefer not to share",
						value: "P",
					},
					{
						label: "I am typing my gender in this blank:",
						value: "O",
						is_other: true,
					},
				],
				function (label) {
					return _.extend(
						{
							checked: false,
							is_other: false,
						},
						label
					);
				}
			);

			if (this.vars.registration.data.gender) {
				var checkedGender = _.findWhere(this.vars.genders, {
					value: this.vars.registration.data.gender,
				});
				if (checkedGender) {
					checkedGender.checked = true;
					this.vars.registration.data.gender_label = checkedGender.label;
					if (checkedGender.is_other) {
						this.vars.registration.data.gender_label =
							"Other – " + this.vars.registration.data.gender_other;
					}
				}
			}
		},
		processMuAlphaThetaBeforeRender: function () {
			this.vars.divisions = [
				{
					value: "Mu",
				},
				{
					value: "Alpha",
				},
				{
					value: "Theta",
				},
			];
			if (this.vars.registration.data.division) {
				var checkedDivision = _.findWhere(this.vars.divisions, {
					value: this.vars.registration.data.division,
				});
				if (checkedDivision) {
					checkedDivision.checked = true;
				}
			}

			// default to checked
			var will_receive_emails_check = !(
				this.vars.registration.data.will_receive_emails === 0
			);
			this.vars.registration.data.will_receive_emails =
				will_receive_emails_check ? 1 : 0;
			this.vars.will_receive_emails_opts = [
				{
					label: "Yes",
					value: 1,
					checked: will_receive_emails_check,
				},
				{
					label: "No",
					value: 0,
					checked: !will_receive_emails_check,
				},
			];
			this.vars.registration.data.will_receive_emails_label =
				this.vars.registration.data.will_receive_emails === 0 ? "No" : "Yes";
		},
		processGaimElementaryBeforeRender: function () {
			// default to checked
			var will_receive_emails_check = !(
				this.vars.registration.data.will_receive_emails === 0
			);
			this.vars.registration.data.will_receive_emails =
				will_receive_emails_check ? 1 : 0;
			this.vars.will_receive_emails_opts = [
				{
					label: "Yes",
					value: 1,
					checked: will_receive_emails_check,
				},
				{
					label: "No",
					value: 0,
					checked: !will_receive_emails_check,
				},
			];
			this.vars.registration.data.will_receive_emails_label =
				this.vars.registration.data.will_receive_emails === 0 ? "No" : "Yes";
		},
		processGaimMiddleBeforeRender: function () {
			// default to checked
			var will_receive_emails_check = !(
				this.vars.registration.data.will_receive_emails === 0
			);
			this.vars.registration.data.will_receive_emails =
				will_receive_emails_check ? 1 : 0;
			this.vars.will_receive_emails_opts = [
				{
					label: "Yes",
					value: 1,
					checked: will_receive_emails_check,
				},
				{
					label: "No",
					value: 0,
					checked: !will_receive_emails_check,
				},
			];
			this.vars.registration.data.will_receive_emails_label =
				this.vars.registration.data.will_receive_emails === 0 ? "No" : "Yes";
		},
	});

	Views.ContestRegisterTeam = AoPS.View.extend({
		template_id: "#contest-register-team-tpl",
		className: "contest-landing-main",
		events: {
			"click .start-team": "startTeam",
			"click .leave-team": "leaveTeam",
			"click .make-team-leader": "makeTeamLeader",
			"click .remove-team-member": "removeTeamMember",
			"click .send-team-invitation": "sendTeamInvitation",
			"click .unsend-team-invitation": "unsendTeamInvitation",
			"click .accept-team-invitation": "acceptTeamInvitation",
			"click .dismiss-team-invitation": "dismissTeamInvitation",
		},
		initialize: function (options) {
			this.contestView = options.contestView;
			this.flavor_method_name = this.model.get("flavor")
				? this.model.get("flavor").get("flavor_method_name")
				: null;

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceBeforeRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceBeforeRender"]();
			}

			this.render();

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceAfterRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceAfterRender"]();
			}

			this.listenTo(this.model, "fetch", _.bind(this.render, this));
		},
		renderCms: function () {
			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "BeforeRender"])
			) {
				this["process" + this.flavor_method_name + "BeforeRender"]();
			}

			this.$el.html(this.model.getCmsTemplate("#register-team-tpl", this.vars));

			if (!this.vars.team_registration_can_edit) {
				this.$(".btn").hide();
			}

			if (
				this.flavor_method_name &&
				_.isFunction(this["process" + this.flavor_method_name + "AfterRender"])
			) {
				this["process" + this.flavor_method_name + "AfterRender"]();
			}
		},
		render: function () {
			this.vars = this.model.export();

			this.renderCms();
		},
		showLoading: function () {
			this.$el.empty().append(AoPS.Page.$loader.clone());
		},
		startTeam: function () {
			var $div = $("<div />")
				.css("max-width", "480px")
				.text("Are you sure that you want to start a new team?");
			if (!this.vars.contest_details_url.includes("/practice/")) {
				$div.append(
					$("<ul />").append(
						$("<li />").text(
							this.vars.registration.is_official
								? "Your team will be competing as MATHCOUNTS Mathletes," +
										" and only MATHCOUNTS Mathletes will be able to join your team."
								: "Your team will be competing as MATHCOUNTS Friends," +
										" and only MATHCOUNTS Friends will be able to join your team."
						)
					)
				);
			}
			if (this.contestView.individualView.isEditMode()) {
				this.contestView.individualView.cancelSubmission();
			}

			AoPS.Contests.Utils.CreateModalConfirm(
				$div,
				_.bind(function () {
					// this.showLoading();
					this.model.createTeam();
				}, this),
				null,
				{confirm_button_ok: "START A NEW TEAM", confirm_button_cancel: "CANCEL"}
			);
		},
		leaveTeam: function () {
			var $div = $("<div />").text(
				"Are you sure that you want to leave this team?"
			);
			if (this.vars.team.team_leader_is_self) {
				if (
					this.vars.team.team_leader_is_self &&
					this.vars.team.num_members > 1
				) {
					AoPS.Contests.Utils.CreateModalAlert(
						"Oops! You cannot leave this team while you are the leader. Please designate a new leader first."
					);
					return;
				} else if (this.vars.num_sent_team_invitations > 0) {
					AoPS.Contests.Utils.CreateModalAlert(
						"Oops! You cannot leave this team while you have invitations pending."
					);
					return;
				}
			}
			AoPS.Contests.Utils.CreateModalConfirm(
				$div,
				_.bind(function () {
					// this.showLoading();
					this.model.leaveTeam();
				}, this),
				null,
				{confirm_button_ok: "LEAVE TEAM", confirm_button_cancel: "CANCEL"}
			);
		},
		makeTeamLeader: function (e) {
			var user_id = parseInt($(e.target).attr("data-user-id"));
			AoPS.Contests.Utils.CreateModalConfirm(
				$("<div />")
					.css("max-width", "480px")
					.text(
						"Are you sure that you want to make this user the team leader? " +
							"Once you do this, you will no longer be able to manage invitations to this team."
					),
				_.bind(function () {
					// this.showLoading();
					this.model.makeTeamLeader(user_id);
				}, this),
				null,
				{confirm_button_ok: "MAKE LEADER", confirm_button_cancel: "CANCEL"}
			);
		},
		removeTeamMember: function (e) {
			var user_id = parseInt($(e.target).attr("data-user-id"));
			AoPS.Contests.Utils.CreateModalConfirm(
				"Are you sure that you want to remove this member from this team?",
				_.bind(function () {
					// this.showLoading();
					this.model.removeTeamMember(user_id);
				}, this),
				null,
				{confirm_button_ok: "REMOVE MEMBER", confirm_button_cancel: "CANCEL"}
			);
		},
		sendTeamInvitation: function () {
			if (this.vars.team.num_invites_remaining > 0) {
				var $div = $("<div />").text(
					"Find an AoPS user to invite to your team!"
				);
				var $block = $("<p />").appendTo($div);
				var $inputBlock = $("<label />")
					.text("Start typing username: ")
					.appendTo($block);
				var $input = $("<input />").appendTo($inputBlock);
				var $displayBlock = $("<div />").text("Invite Member: ");
				var $selectedUser = $("<strong />").appendTo($displayBlock);
				var $removeUser = $("<a />").text("Remove");
				var user_id = 0,
					username;
				var modal;

				$displayBlock
					.append(" (")
					.append(
						$removeUser.click(
							_.bind(function () {
								user_id = 0;
								$displayBlock.detach();
								$inputBlock.appendTo($block);
								setTimeout(function () {
									$input.focus();
								}, 200);
							}, this)
						)
					)
					.append(")");

				$input.aopsAutocomplete({
					source: function (request, response) {
						$.ajax({
							method: "post",
							url: "/community/ajax.php",
							data: {
								a: "fetch_username_matches",
								username_stub: request.term,
								aops_session_id: AoPS.session.id,
							},
						})
							.done(function (data) {
								if (!data.error_code && !data.error_msg) {
									response(
										_.map(data.response.usernames, function (match) {
											return {
												value: match.value,
												user_id: parseInt(match.user_id),
											};
										})
									);
								} else {
									response([]);
								}
							})
							.fail(function () {
								response([]);
							});
					},
					minLength: 2,
					onSelect: _.bind(function (event, ui) {
						event.stopPropagation();
						event.preventDefault();

						if (ui.item.user_id) {
							user_id = ui.item.user_id;
							username = ui.item.value;

							$selectedUser.text(username);
							$inputBlock.detach();
							$displayBlock.appendTo($block);
						}

						return false;
					}, this),
				});

				modal = AoPS.Ui.Modal.showConfirm(
					$div,
					_.bind(function (ok) {
						if (ok) {
							if (user_id) {
								if (
									_.findWhere(this.vars.team.data.members, {user_id: user_id})
								) {
									AoPS.Contests.Utils.CreateModalAlert(
										"Oops! " +
											username +
											" is already on this team. Please invite another user."
									);
								} else if (
									_.findWhere(this.vars.team.data.invites, {user_id: user_id})
								) {
									AoPS.Contests.Utils.CreateModalAlert(
										"Oops! " +
											username +
											" has already been invited. Please invite another user."
									);
								} else {
									AoPS.Ui.Modal.removeModal(modal);
									this.model.sendTeamInvitation(user_id);
								}
							} else {
								AoPS.Contests.Utils.CreateModalAlert(
									"Oops! You have not selected a user. Please try again."
								);
							}
						} else {
							AoPS.Ui.Modal.removeModal(modal);
						}
					}, this),
					{
						confirm_button_ok: "INVITE MEMBER",
						confirm_button_cancel: "CANCEL",
						close_on_button_click: false,
					}
				);

				setTimeout(function () {
					$input.focus();
				}, 200);
			} else {
				AoPS.Contests.Utils.CreateModalAlert(
					"Oops! Your team cannot have more than " +
						this.vars.max_team_size +
						" team members or invitations out at any time."
				);
			}
		},
		unsendTeamInvitation: function (e) {
			var user_id = parseInt($(e.target).attr("data-user-id"));
			AoPS.Contests.Utils.CreateModalConfirm(
				"Are you sure that you want to uninvite this user?",
				_.bind(function () {
					// this.showLoading();
					this.model.unsendTeamInvitation(user_id);
				}, this),
				null,
				{confirm_button_ok: "UNINVITE MEMBER", confirm_button_cancel: "CANCEL"}
			);
		},
		acceptTeamInvitation: function (e) {
			if (this.vars.team.contest_team_id) {
				AoPS.Contests.Utils.CreateModalAlert(
					"Oops! You cannot accept an invitation while you are on a team."
				);
			} else {
				var contest_team_id = parseInt($(e.target).attr("data-team-id"));
				AoPS.Contests.Utils.CreateModalConfirm(
					"Are you sure that you want to accept this team invitation?",
					_.bind(function () {
						// this.showLoading();
						this.model.acceptTeamInvitation(contest_team_id);
					}, this),
					null,
					{
						confirm_button_ok: "ACCEPT INVITATION",
						confirm_button_cancel: "CANCEL",
					}
				);
			}
		},
		dismissTeamInvitation: function (e) {
			var contest_team_id = parseInt($(e.target).attr("data-team-id"));
			AoPS.Contests.Utils.CreateModalConfirm(
				"Are you sure that you want to dismiss this team invitation?",
				_.bind(function () {
					// this.showLoading();
					this.model.dismissTeamInvitation(contest_team_id);
				}, this),
				null,
				{
					confirm_button_ok: "DISMISS INVITATION",
					confirm_button_cancel: "CANCEL",
				}
			);
		},
		processMathcountsWeekOnceAfterRender: function () {
			// Nothing for now.
		},
	});

	Views.ContestRegistrationFull = AoPS.View.extend({
		template_id: "#contest-registration-full-tpl",
		className: "contest-landing-main",
		initialize: function (options) {
			this.contestView = options.contestView;
			this.showError = false;
			this.contestUrl = "/contests/" + this.model.get("contest_hash");

			this.flavor_method_name = this.model.get("flavor")
				? this.model.get("flavor").get("flavor_method_name")
				: null;
			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceBeforeRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceBeforeRender"]();
			}

			this.render();

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceAfterRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceAfterRender"]();
			}
		},
		render: function () {
			this.$el.empty().append(
				$("<div />").html(
					this.getTemplate(this.template_id, {
						contest_name: this.model.get("contest_name"),
					})
				)
			);
		},
	});

	Views.ContestRegisterCoppaCheck = AoPS.View.extend({
		template_id: "#contest-coppa-check-tpl",
		className: "contest-landing-main",
		initialize: function (options) {
			this.contestView = options.contestView;
			this.vars = {
				show_error: false,
				contest_url: "/contests/" + this.model.get("contest_hash"),
				contest_name: this.model.get("contest_short_name"),
			};

			this.flavor_method_name = this.model.get("flavor")
				? this.model.get("flavor").get("flavor_method_name")
				: null;
			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceBeforeRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceBeforeRender"]();
			}

			this.render();

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceAfterRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceAfterRender"]();
			}
		},
		render: function () {
			this.setVars();
			this.$el
				.empty()
				.append(
					$("<div />").html(this.getTemplate(this.template_id, this.vars))
				);

			this.$("#coppa-dob select").change(_.bind(this.render, this));
			this.$("#btn-continue").click(_.bind(this.processPrecoppaInput, this));
		},
		setVars: function () {
			if (!this.vars.years) {
				var max = new Date().getFullYear() - 3;
				var min = max - 100;
				this.vars.years = _.map(_.range(max, min - 1, -1), function (year) {
					return {label: year, val: year};
				});
			}

			if (!this.vars.months) {
				this.vars.months = _.map(_.range(1, 13), function (month) {
					return {
						label: moment()
							.set("month", month - 1)
							.format("MMMM"),
						val: month,
					};
				});
			}

			this.vars.selectedMonth = Number($("#select-month").val());
			this.vars.selectedDay = Number($("#select-day").val());
			this.vars.selectedYear = Number($("#select-year").val());

			// Only allow days that exist.
			if (this.vars.selectedMonth && this.vars.selectedYear) {
				this.vars.days = _.map(
					_.range(
						1,
						moment()
							.set("year", this.vars.selectedYear)
							.set("month", this.vars.selectedMonth - 1)
							.daysInMonth() + 1
					),
					function (day) {
						return {label: day, val: day};
					}
				);
			} else {
				this.vars.days = [];
			}

			if (this.vars.selectedYear) {
				_.each(
					this.vars.years,
					_.bind(function (obj) {
						obj.selected = obj.val === this.vars.selectedYear;
					}, this)
				);
			}
			if (this.vars.selectedMonth) {
				_.each(
					this.vars.months,
					_.bind(function (obj) {
						obj.selected = obj.val === this.vars.selectedMonth;
					}, this)
				);
			}
			if (this.vars.selectedDay) {
				_.each(
					this.vars.days,
					_.bind(function (obj) {
						obj.selected = obj.val === this.vars.selectedDay;
					}, this)
				);
			}
		},
		processPrecoppaInput: function () {
			var invitation = this.model.get("current_invitation");
			var dob = moment([
				this.vars.selectedYear,
				this.vars.selectedMonth - 1,
				this.vars.selectedDay,
			]);
			var valid = this.validateDob(dob);

			if (valid) {
				var window = this.model.computeWindow();
				var data = {
					is_complete: 0,
					is_coppa: this.isCoppaRequired(dob) ? 1 : 0,
					// COPPA contests don't overlap official and unofficial registration
					is_official: window.get("official_registration_can_access"),
				};
				if (invitation) {
					data.invite_id = invitation.invite_id;
					Object.assign(data, invitation.data);
				}
				this.model.registerUser(data);
			} else {
				this.vars.show_error = true;
				this.render();
			}
		},
		validateDob: function (dob) {
			if (
				this.vars.selectedYear &&
				this.vars.selectedMonth &&
				this.vars.selectedDay
			) {
				return dob.isValid();
			}
			return false;
		},
		isCoppaRequired: function (dob) {
			dob = moment(dob, "YYYY-MM-DD");
			return !dob.isBefore(moment().subtract(13, "y"));
		},
	});

	Views.ContestRegisterCoppaBlock = AoPS.View.extend({
		template_id: "#contest-coppa-block-tpl",
		className: "contest-landing-main",
		initialize: function (options) {
			this.contestView = options.contestView;

			this.coppaUrl =
				"https:" +
				AoPS.bd.data_uri +
				"contest_coppa/" +
				this.model.get("coppa_pdf");

			this.flavor_method_name = this.model.get("flavor")
				? this.model.get("flavor").get("flavor_method_name")
				: null;
			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceBeforeRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceBeforeRender"]();
			}

			this.render();

			if (
				this.flavor_method_name &&
				_.isFunction(
					this["process" + this.flavor_method_name + "OnceAfterRender"]
				)
			) {
				this["process" + this.flavor_method_name + "OnceAfterRender"]();
			}
		},
		render: function () {
			this.$el.empty().append(
				$("<div />").html(
					this.getTemplate(this.template_id, {
						coppa_url: this.coppaUrl,
						coppa_email: this.model.get("coppa_email"),
						privacy_statement: this.model.get("privacy_statement"),
					})
				)
			);
		},
	});

	return Views;
})(AoPS.Contests.Views);
